import { PrepaySearchModel } from "@app/models/myoffice/order/prepay-search.model";
import { ResultProc } from "@app/models/system/result-proc.model";
import { prepayFeatureKey } from "@app/reducers/myoffice/order/prepay.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export interface PrepayState {
    resultPayPrepay: ResultProc,
    resultSavePrepay: ResultProc,
    searchItems: PrepaySearchModel[],
    totalItems: Number,
    checkPreItems: Number,
    resultDelete:ResultProc
}

export const getPrepayState = createFeatureSelector<PrepayState>(prepayFeatureKey);

export const getPayCardPrepay = createSelector(
    getPrepayState,
    (state: PrepayState) => state.resultPayPrepay
);

export const getSavePrepay = createSelector(
    getPrepayState,
    (state: PrepayState) => state.resultSavePrepay
);

export const getPrepaySearchItems = createSelector(
    getPrepayState,
    (state: PrepayState) => state.searchItems
);

export const getPrepayTotalItems = createSelector(
    getPrepayState,
    (state: PrepayState) => state.totalItems
);

export const getCheckPreItem = createSelector(
    getPrepayState,
    (state: PrepayState) => state.checkPreItems
);

export const getResultDelete = createSelector(
    getPrepayState,
    (state: PrepayState) => state.resultDelete
);